module.exports = __webpack_public_path__ + "img/syukyaku-landing-001sp.325f1f06.jpg";